<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-text-field  label="Search" placeholder="Search" class="px-1"
                       v-model="search"
                       clearable
                       flat dense
                       solo-inverted
                       hide-details
                       prepend-inner-icon="mdi-magnify"
        ></v-text-field>
<!--        @change="$router.replace({name: $route.name, query: {...$route.query, search: search}})"-->

        <v-btn small class="ml-3 box-shadow" color="primary" :to="{name: 'Create session'}">Create new</v-btn>
      </template>
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="3">
          <v-card>
            <v-card-text class="text-center">
              <v-btn-toggle v-model="period" mandatory color="primary">
                <v-btn small value="default">Default</v-btn>
                <v-btn small value="today">Today</v-btn>
                <v-btn small value="tomorrow">Tomorrow</v-btn>
                <!--                <v-btn small value="3month">3 months</v-btn>-->
                <!--                <v-btn small value="6month">6 months</v-btn>-->
                <!--                <v-btn small value="all">All</v-btn>-->
              </v-btn-toggle>
            </v-card-text>
            <v-divider/>
            <v-card-text>
              <date-field input-class="mx-2" flat dense solo-inverted label="From" v-model="date_from" clearable></date-field>
              <date-field input-class="mx-2" flat dense solo-inverted label="Till" v-model="date_to" clearable></date-field>

            </v-card-text>
            <v-divider/>
            <v-card-text>
              <v-select label="Tutor" class="px-1"
                        :items="tutors"
                        v-model="tutor"
                        item-value="id"
                        item-text="nickname"
                        clearable dense solo-inverted
              />

              <v-select label="Practice area" class="px-1"
                        :items="practice_areas"
                        v-model="practice_area"
                        item-value="id"
                        item-text="name"
                        clearable dense solo-inverted
              />
              <v-select label="Session type" class="px-1"
                        :items="session_types"
                        v-model="session_type"
                        item-value="id"
                        item-text="name"
                        clearable dense solo-inverted
              />

              <v-select label="Assigment status" class="px-1"
                        :items="assigment_status_opts"
                        v-model="assigment_status"
                        clearable dense solo-inverted
              />

            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="9" class="pl-md-0">
          <v-card>
            <v-data-table :headers="table_data.headers"
                          :items="table_data_items"
                          :search="search"
                          :items-per-page="15"
            >
              <template v-slot:item.start="{ value }">
                {{ $moment(value).format('DD/MM/YYYY hh:mm A') }}
              </template>
              <template v-slot:item.deadline="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY hh:mm A') : null }}
              </template>
              <template v-slot:item.ready="{ item }">
                <template v-if="item.ready">
                  <template v-if="$moment(item.deadline).isBefore($moment(item.ready))">
                    <v-icon color="error">mdi-alarm</v-icon>
                    <span> {{ $moment(item.ready).format("DD/MM/YYYY hh:mm A") }}</span>
                  </template>
                  <template v-else>
                    <v-icon color="success" v-if="item.ready">mdi-checkbox-marked-circle</v-icon>
                    <span> {{ $moment(item.ready).format("DD/MM/YYYY hh:mm A") }}</span>
                  </template>
                </template>
              </template>

              <template v-slot:item.return_marked="{ value }">
                {{ value ? $moment(value).format('DD/MM/YYYY hh:mm A') : null }}
              </template>
              <template v-slot:item.end="{ item }">
                <v-icon color="success" v-if="item.marked">mdi-checkbox-marked-circle</v-icon>
                <span> {{ $moment(item.end).format("DD/MM/YYYY hh:mm A") }}</span>
              </template>

              <template v-slot:item.marked="{ value }">
                <v-icon color="success" v-if="value">mdi-checkbox-marked-circle</v-icon>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn small color="primary" @click="openItem(item)">open</v-btn>
                <!--            <v-icon class="mr-2" @click="openItem(item)">mdi-pencil</v-icon>-->
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="create_item_dialog" max-width="980px" @click:outside="closeCreateItemDialog">
      <v-form class="text-center" @submit="saveCreateItem">
        <v-card class="box-shadow" v-if="create_item">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeCreateItemDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Create new</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text type="submit" color="success">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="Name"
                              v-model="create_item.name"
                              color="secondary"
                              type="text"
                              validate-on-blur
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field label="Short Name"
                              v-model="create_item.short_name"
                              color="secondary"
                              type="text"
                              validate-on-blur
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider/>

          <v-card-subtitle class="box-shadow">Dates for recruitment of candidates for the group</v-card-subtitle>
          <v-divider/>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="6" class="my-0">
                <date-field label=""
                            v-model="create_item.recruitment_period[0]"
                            :error-messages="api_errors['recruitment_period']"
                />
              </v-col>
              <v-col cols="12" md="6" class="my-0">
                <date-field label=""
                            v-model="create_item.recruitment_period[1]"
                            :error-messages="api_errors['recruitment_period']"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider/>
          <v-card-subtitle class="box-shadow">Study period</v-card-subtitle>
          <v-divider/>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="6" class="my-0">
                <date-field label=""
                            v-model="create_item.study_period[0]"
                            :error-messages="api_errors['study_period']"
                />
              </v-col>
              <v-col cols="12" md="6" class="my-0">
                <date-field label=""
                            v-model="create_item.study_period[1]"
                            :error-messages="api_errors['study_period']"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider/>
          <v-card-subtitle class="box-shadow">Visits filtering end</v-card-subtitle>
          <v-divider/>
          <v-card-text class="py-0">
            <date-field
                v-model="create_item.visits_filtering_end"
                :error-messages="api_errors['visits_filtering_end']"
            />
          </v-card-text>

          <v-divider/>
          <v-card-text class="py-0">
            <v-row>
              <v-col cols="12" md="6" class="py-0">
                <v-switch label="Members only"
                          v-model="create_item.members_only"
                          false-value="0"
                          :error-messages="api_errors['members_only']"/>
              </v-col>
              <v-col cols="12" md="6" class="py-0">
                <v-switch label="Members auto-approve"
                          v-model="create_item.members_auto_approve"
                          false-value="0"
                          :error-messages="api_errors['members_auto_approve']"/>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider/>
          <v-card-subtitle class="box-shadow">Booking Policy</v-card-subtitle>
          <v-divider/>
          <vue-editor id="study_group_booking_policy" v-model="create_item.booking_policy" :editor-toolbar="toolbar"></vue-editor>

        </v-card>
      </v-form>
    </v-dialog>
  </section>
</template>

<script>
import DateField from "@/components/DateField";
import {mapGetters} from "vuex";
export default {
  components: {DateField},
  props: {
    study_groups: {
      type: Array,
      default: Array,
    }
  },
  data: () => ({
    date_from: localStorage.getItem('sessions.date_from') || '',
    date_to: localStorage.getItem('sessions.date_to') || '',
    table_data: {
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'User', value: 'user.full_name' },
        { text: 'Email', value: 'user.email' },
        { text: 'Tutor', value: 'tutor.nickname' },
        { text: 'Mock', value: 'short_name' },
        // { text: 'Short Name', value: 'short_name' },
        // { text: 'Accessor', value: 'accessor.public_id' },

        // { text: 'Session type', value: 'session_type.name' },
        // { text: 'Practice area', value: 'practice_area.name' },
        { text: 'Date', value: 'start' },
        { text: 'Submit by', value: 'deadline' },
        { text: 'Submitted', value: 'ready' },
        { text: 'Mark by', value: 'end' },
        // { text: 'Marked', value: 'marked' },
        { text: 'Mark', value: 'final_mark' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],

    },
    period: 'default',
    period_opts: [
      'default',
      'today',
      'tomorrow',
      '3month',
      '6month',
      'all',
    ],
    tutors: [],
    assigment_status_opts: [
      {text: 'Waiting', value: 'waiting'},
      {text: 'Submitted for marking', value: 'submitted'},
      {text: 'Marked submissions', value: 'marked'},
    ],

    search: localStorage.getItem('sessions.search') || '',
    tutor: parseInt(localStorage.getItem('sessions.tutor')) || null,
    practice_area: parseInt(localStorage.getItem('sessions.practice_area')) || null,
    session_type: parseInt(localStorage.getItem('sessions.session_type')) || null,
    assigment_status: localStorage.getItem('sessions.assigment_status') || null,

    create_item: null,
    create_item_dialog: false,
    selected_item_dialog: false,
    selected_item: null,

    api_errors: [],
  }),
  computed: {
    ...mapGetters({
      session_types: 'getSessionTypes',
      practice_areas: 'getPracticeAreas',
    }),
    table_data_items: function () {
      let items = []

      items.push(...this.table_data.items)

      if(this.date_from && this.date_to) {
        let date_from = this.$moment(this.date_from, 'YYYY-MM-DD');
        let date_to = this.$moment(this.date_to, 'YYYY-MM-DD');
        let filter_range = this.$moment.range(date_from, date_to);

        items = items.filter(item => {
          if(filter_range.contains(this.$moment(item.start, 'YYYY-MM-DD'))) return item
          if(filter_range.contains(this.$moment(item.end, 'YYYY-MM-DD'))) return item
          let start = this.$moment(item.start, 'YYYY-MM-DD')
          let end = this.$moment(item.end, 'YYYY-MM-DD')
          let item_range = this.$moment.range(start, end);

          if(item_range.contains(this.$moment(date_from, 'YYYY-MM-DD'))) return item
          if(item_range.contains(this.$moment(date_to, 'YYYY-MM-DD'))) return item
        })
      }

      if(this.tutor) {
        items = items.filter(item => item.tutor_id === this.tutor)
      }

      if(this.practice_area) {
        items = items.filter(item => item.practice_area_id === this.practice_area)
      }
      if(this.session_type) {
        items = items.filter(item => item.session_type_id === this.session_type)
      }

      if(this.assigment_status) {
        if (this.assigment_status === 'waiting') {
          items = items.filter(item => item.ready === null && item.marked === null)
        }

        if (this.assigment_status === 'submitted') {
          items = items.filter(item => item.ready !== null && item.marked === null)
        }

        if (this.assigment_status === 'marked') {
          items = items.filter(item => item.ready !== null && item.marked !== null)
        }
      }

      return items
    },
  },
  watch: {
    'period': function (val) {
      switch(val) {
        case 'today':
          this.date_from = this.$currentTime().format('YYYY-MM-DD')
          this.date_to = this.$currentTime().format('YYYY-MM-DD')
          break;
        case 'tomorrow':
          this.date_from = this.$currentTime().add(1, 'days').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(1, 'days').format('YYYY-MM-DD')
          break;
        case '3month':
          this.date_from = this.$currentTime().subtract(3, 'month').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
          break;
        case '6month':
          this.date_from = this.$currentTime().subtract(6, 'month').format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
          break;

          // case 'all':
          //   this.date_from = null
          //   this.date_to = null
          //   break;
        default:
          this.date_from = this.$currentTime().format('YYYY-MM-DD')
          this.date_to = this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
      }
    },
    'date_from': function(val) {
      localStorage.setItem('sessions.date_from', val)
    },
    'date_to': function(val) {
      localStorage.setItem('sessions.date_to', val)
    },
    'search': (val) => { localStorage.setItem('sessions.search', val || '')},
    'tutor': (val) => { localStorage.setItem('sessions.tutor', val)},
    'practice_area': (val) => { localStorage.setItem('sessions.practice_area', val)},
    'session_type': (val) => { localStorage.setItem('sessions.session_type', val)},
    'assigment_status': (val) => { localStorage.setItem('sessions.assigment_status', val)},
  },
  created() {
    if(!this.date_from) this.date_from = this.$currentTime().format('YYYY-MM-DD')
    if(!this.date_to) this.$currentTime().add(10, 'days').format('YYYY-MM-DD')
    this.loadData()
    this.loadTutors()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/sessions`, {
        // params:{date_from: this.date_from, date_to: this.date_to}
      })
          .then(({data}) => data.data)
    },
    loadTutors() {
      this.axios.get(`api/tutors`).then(response => {this.tutors = response.data.data })
    },
    openCreateItemDialog() {
      this.create_item_dialog = true;
      this.create_item = {
        name: '',
        short_name: '',
        recruitment_period: [],
        study_period: [],
        visits_filtering_end: '',
        members_only: false,
        members_auto_approve: false,
        booking_policy: '',
      }
    },
    closeCreateItemDialog() {
      this.create_item_dialog = false;
      this.create_item = null
    },
    saveCreateItem(e) {
      e.preventDefault()
      this.api_errors = []
      this.axios.post(`api/study-groups`, this.create_item)
          .then(({data}) => {
            this.table_data.items.unshift(data.data)
            this.closeCreateItemDialog()
          })
          .catch(({response}) => { this.api_errors = response.data.errors })
    },
    openItem(item) {
      this.$router.push({name: 'Session', params: {session_id: item.id}})
    }
  }
}
</script>
